/** @jsx tsx */
import { WidgetProperties } from "@dojo/framework/core/interfaces";
import { WidgetBase } from "@dojo/framework/core/WidgetBase";
import { CsiDrag, IDragResults } from "../meta/Drag/index";

export abstract class DraggableWidget<P = WidgetProperties> extends WidgetBase<P> {
	/**
     * Flag to indicate if dragging is started or not
     */
	private _dragging = false;

	/**
     * Remove all pointer event listeners on shape
     */
	protected onDetach(): void {
		this.meta(CsiDrag)
			.remove(this.properties.key as string);
	}

    /**
     * Abstract template method to render object based on its kind. Either shape or group shape or line or picture
     * @returns {DNode} Virtual dom for page object kind
     */
    protected abstract onDrag(drag: IDragResults, isComplete: boolean): void;

    protected _onDrag(drag: IDragResults) {
    	// if dragging is not yet started return
    	if (!this._dragging && !drag.isDragging) {
    		return;
    	}

    	if (this._dragging && !drag.isDragging) {
    		// if previously dragging was true and now dragResults say it is false then dragging is stopped.
    		this._dragging = false;
    	} else if (!drag.delta.x && !drag.delta.y) {
    		// during dragging if there is no delta then return
    		return true;
    	} else {
    		if (drag.delta.x !== 0 || drag.delta.y !== 0) {
    			this._dragging = true;
    		} else {
    			return true;
    		}
    	}
    	this.onDrag(drag, !this._dragging);
    }

    protected requestDragMeta(key: string, type?: string) {
    	const dragResult: IDragResults = this.meta(CsiDrag)
    		.get(key, type);
    	this._onDrag(dragResult);
    }
};
